import * as types from './mutation-types'

export default {
  [types.ADMIN_AUTH_LOGIN](state, payload) {
    state.auth.ircd = payload.userId
    state.auth.token = payload.token
  },
  [types.ADMIN_AUTH_LOGOUT](state) {
    state.auth.ircd = ''
    state.auth.userId = ''
    state.auth.token = ''

    state.commonUserInfo.pram = ''
    state.commonUserInfo.irnm = ''
    state.commonUserInfo.name = ''

    // 管理者用データ 各画面用ストア値の初期化
    state.adminUserChoice.statusGlobalMenu = '0'

    state.adminUserChoice.MasterWTMZN.tmzn = ''
    state.adminUserChoice.MasterWTMZN.err = ''

    state.adminUserChoice.MasterWKKMM.kmcd = ''

    state.adminUserChoice.MasterWWAKU.waku = ''

    state.adminUserChoice.MasterWMAIL.mrcd = ''

    state.adminUserChoice.MasterWOPBR.opbr = ''

    state.adminUserChoice.MasterWOPKM.opbr = ''
    state.adminUserChoice.MasterWOPKM.opcd = ''

    state.adminUserChoice.MasterWJGYO.jgcd = ''

    state.adminUserChoice.MasterWHFKB.jgcd = ''
    state.adminUserChoice.MasterWHFKB.hfkb = ''

    state.adminUserChoice.MasterWIRKS.searchJgcd = ''
    state.adminUserChoice.MasterWIRKS.nend = ''
    state.adminUserChoice.MasterWIRKS.jgcd = ''
    state.adminUserChoice.MasterWIRKS.kscd = ''
    state.adminUserChoice.MasterWIRKS.key = ''

    state.adminUserChoice.MasterWIGA1.ukno = ''
    state.adminUserChoice.MasterWIGA1.changeDateFlag = false
    state.adminUserChoice.MasterWIGA1.changeDateYear = 0
    state.adminUserChoice.MasterWIGA1.changeDateMonth = 0
    state.adminUserChoice.MasterWIGA1.changeDateDate = 0
    state.adminUserChoice.MasterWIGA1.changeDateTmzn = ''

    state.adminUserChoice.CSVPattern.ptcd = ''

    // 管理者用データ 受診者抽出画面　絞り込み欄の初期化
    state.adminWiga11Search.jgcd = ''
    state.adminWiga11Search.jgnm = ''
    state.adminWiga11Search.cmnm = ''
    state.adminWiga11Search.hkkg = ''
    state.adminWiga11Search.trno = ''
    state.adminWiga11Search.waku = ''
    state.adminWiga11Search.ukno = ''
    state.adminWiga11Search.nend = 0
    state.adminWiga11Search.opbr = ''
    state.adminWiga11Search.opcd = ''
    state.adminWiga11Search.ykdyStartYear = 0
    state.adminWiga11Search.ykdyStartMonth = 0
    state.adminWiga11Search.ykdyStartDate = 0
    state.adminWiga11Search.ykdyEndYear = 0
    state.adminWiga11Search.ykdyEndMonth = 0
    state.adminWiga11Search.ykdyEndDate = 0
    state.adminWiga11Search.crdtStartYear = 0
    state.adminWiga11Search.crdtStartMonth = 0
    state.adminWiga11Search.crdtStartDate = 0
    state.adminWiga11Search.crdtEndYear = 0
    state.adminWiga11Search.crdtEndMonth = 0
    state.adminWiga11Search.crdtEndDate = 0
    state.adminWiga11Search.updtStartYear = 0
    state.adminWiga11Search.updtStartMonth = 0
    state.adminWiga11Search.updtStartDate = 0
    state.adminWiga11Search.updtEndYear = 0
    state.adminWiga11Search.updtEndMonth = 0
    state.adminWiga11Search.updtEndDate = 0

    state.adminWiga11Search.ykst = []
    state.adminWiga11Search.ryak = ''
    state.adminWiga11Search.name = ''
    state.adminWiga11Search.csst = []
    state.adminWiga11Search.tmzn = ''

  },

  [types.ADMIN_USERINFO_SETUSERINFO](state, payload) {
    state.adminLoginUserInfo.irnm = payload.irnm
  },

  // 管理者用グローバルメニューの状態を変更する
  // 0:デフォルト表示（何も表示しない）
  // 1:トップ
  // 2:予約管理系メニュー表示
  // 3:マスタ管理系メニュー表示
  [types.ADMIN_USERCHOICE_STATUSGLOBALMENU](state, payload) {
    state.adminUserChoice.statusGlobalMenu = payload.statusGlobalMenu
  },

  [types.ADMIN_USERCHOICE_WTMZN_LISTTODETAIL](state, payload) {
    // 時間帯マスタ一覧画面から更新画面に遷移する際に
    // 時間帯コードをストアに保存
    state.adminUserChoice.MasterWTMZN.tmzn = payload.tmzn
  },

  [types.ADMIN_USERCHOICE_WKKMM_LISTTODETAIL](state, payload) {
    // 検査項目マスタ一覧画面から更新画面に遷移する際に
    // 検査項目コードをストアに保存
    state.adminUserChoice.MasterWKKMM.kmcd = payload.kmcd
  },

  [types.ADMIN_USERCHOICE_WWAKU_LISTTODETAIL](state, payload) {
    // 予約枠マスタ一覧画面から更新画面に遷移する際に
    // 予約枠コードをストアに保存
    state.adminUserChoice.MasterWWAKU.waku = payload.waku
  },

  [types.ADMIN_USERCHOICE_WMAIL_LISTTODETAIL](state, payload) {
    // メールテンプレートマスタ一覧画面から更新画面に遷移する際に
    // 管理コードをストアに保存
    state.adminUserChoice.MasterWMAIL.mrcd = payload.mrcd
  },

  [types.ADMIN_USERCHOICE_WOPBR_LISTTODETAIL](state, payload) {
    // オプション分類一覧画面から更新画面に遷移する際に
    // オプション分類をストアに保存
    state.adminUserChoice.MasterWOPBR.opbr = payload.opbr
  },

  [types.ADMIN_USERCHOICE_WOPKM_LISTTODETAIL](state, payload) {
    // オプション項目一覧画面から更新画面に遷移する際に
    // オプション分類をストアに保存
    // オプションコードをストアに保存
    state.adminUserChoice.MasterWOPKM.opbr = payload.opbr
    state.adminUserChoice.MasterWOPKM.opcd = payload.opcd
  },

  [types.ADMIN_USERCHOICE_WJGYO_LISTTODETAIL](state, payload) {
    // クライアント一覧画面から更新画面に遷移する際に
    // クライアントコードをストアに保存
    state.adminUserChoice.MasterWJGYO.jgcd = payload.jgcd
  },

  [types.ADMIN_USERCHOICE_WHFKB_LISTTODETAIL](state, payload) {
    // 対象者区分マスタ一覧画面から更新画面に遷移する際に
    // クライアントコードをストアに保存
    // 対象者区分コードをストアに保存
    state.adminUserChoice.MasterWHFKB.jgcd = payload.jgcd
    state.adminUserChoice.MasterWHFKB.hfkb = payload.hfkb
  },

  [types.ADMIN_USERCHOICE_WIRKS_SEARCH](state, payload) {
    // コースマスタ操作時 クライアントコードで検索したとき
    state.adminUserChoice.MasterWIRKS.searchJgcd = payload.searchJgcd
  },

  [types.ADMIN_USERCHOICE_WIRKS_LISTTOREGISTER](state, payload) {
    // コースマスタ一覧画面から更新画面に遷移する際に
    // クライアントコードをストアに保存
    state.adminUserChoice.MasterWIRKS.nend = 0
    state.adminUserChoice.MasterWIRKS.jgcd = payload.jgcd
    state.adminUserChoice.MasterWIRKS.kscd = ''
    state.adminUserChoice.MasterWIRKS.key = ''
  },

  [types.ADMIN_USERCHOICE_WIRKS_LISTTOHOME](state) {
    // コースマスタ一覧画面からメニューに戻る際に
    // 各ストア値を初期化
    state.adminUserChoice.MasterWIRKS.nend = 0
    state.adminUserChoice.MasterWIRKS.jgcd = ''
    state.adminUserChoice.MasterWIRKS.kscd = ''
    state.adminUserChoice.MasterWIRKS.key = ''
  },

  [types.ADMIN_USERCHOICE_WIRKS_BULK](state, payload) {
    // コースマスタ一覧画面から更新画面に遷移する際に
    // 年度をストアに保存
    // クライアントコードをストアに保存
    // 健診コースコードをストアに保存
    state.adminUserChoice.MasterWIRKS.nend = 0
    state.adminUserChoice.MasterWIRKS.jgcd = payload.jgcd
    state.adminUserChoice.MasterWIRKS.kscd = ''
    state.adminUserChoice.MasterWIRKS.key = ''
  },

  [types.ADMIN_USERCHOICE_WIRKS_LISTTODETAIL](state, payload) {
    // コースマスタ一覧画面から更新画面に遷移する際に
    // 年度をストアに保存
    // クライアントコードをストアに保存
    // 健診コースコードをストアに保存
    state.adminUserChoice.MasterWIRKS.nend = payload.nend
    state.adminUserChoice.MasterWIRKS.jgcd = payload.jgcd
    state.adminUserChoice.MasterWIRKS.kscd = payload.kscd
    state.adminUserChoice.MasterWIRKS.key = ''
  },

  [types.ADMIN_USERCHOICE_WIRKS_LISTTOIRKM](state, payload) {
    // コースマスタ一覧画面からコース毎検査項目画面に遷移する際に
    // 年度をストアに保存
    // クライアントコードをストアに保存
    // 健診コースコードをストアに保存
    // キーをストアに保存
    state.adminUserChoice.MasterWIRKS.nend = payload.nend
    state.adminUserChoice.MasterWIRKS.jgcd = payload.jgcd
    state.adminUserChoice.MasterWIRKS.kscd = payload.kscd
    state.adminUserChoice.MasterWIRKS.key = payload.key
  },

  [types.ADMIN_USERCHOICE_WIRKS_LISTTOKSWK](state, payload) {
    // コースマスタ一覧画面からコース毎予約枠画面に遷移する際に
    // 年度をストアに保存
    // クライアントコードをストアに保存
    // 健診コースコードをストアに保存
    // キーをストアに保存
    state.adminUserChoice.MasterWIRKS.nend = payload.nend
    state.adminUserChoice.MasterWIRKS.jgcd = payload.jgcd
    state.adminUserChoice.MasterWIRKS.kscd = payload.kscd
    state.adminUserChoice.MasterWIRKS.key = payload.key
  },

  [types.ADMIN_USERCHOICE_WIRKS_LISTTORKKS](state, payload) {
    // コースマスタ一覧画面からコース毎料金条件画面に遷移する際に
    // 年度をストアに保存
    // クライアントコードをストアに保存
    // 健診コースコードをストアに保存
    // キーをストアに保存
    state.adminUserChoice.MasterWIRKS.nend = payload.nend
    state.adminUserChoice.MasterWIRKS.jgcd = payload.jgcd
    state.adminUserChoice.MasterWIRKS.kscd = payload.kscd
    state.adminUserChoice.MasterWIRKS.key = payload.key
  },
  
  [types.ADMIN_USERCHOICE_WIRKS_LISTTOOPTION](state, payload) {
    // コースマスタ一覧画面からコース毎オプション画面に遷移する際に
    // 年度をストアに保存
    // クライアントコードをストアに保存
    // 健診コースコードをストアに保存
    // キーをストアに保存
    state.adminUserChoice.MasterWIRKS.nend = payload.nend
    state.adminUserChoice.MasterWIRKS.jgcd = payload.jgcd
    state.adminUserChoice.MasterWIRKS.kscd = payload.kscd
    state.adminUserChoice.MasterWIRKS.key = payload.key
  },

  [types.ADMIN_USERCHOICE_WIRKS_BACKTOLIST](state) {
    // 各関連画面（※）からコースマスタ画面に遷移する際に
    // 年度をストアに保存
    // クライアントコードをストアに保存
    // 健診コースコードをストアに保存
    // キーをストアに保存
    state.adminUserChoice.MasterWIRKS.nend = 0
    state.adminUserChoice.MasterWIRKS.jgcd = ''
    state.adminUserChoice.MasterWIRKS.kscd = ''
    state.adminUserChoice.MasterWIRKS.key = ''
  },

  [types.ADMIN_USERCHOICE_WIGA1_DETAIL](state, payload) {
    // 受診者抽出から予約状況詳細へ
    state.adminUserChoice.MasterWIGA1.ukno = payload.ukno
    state.adminUserChoice.MasterWIGA1.changeDateFlag = false
    state.adminUserChoice.MasterWIGA1.changeDateYear = 0
    state.adminUserChoice.MasterWIGA1.changeDateMonth = 0
    state.adminUserChoice.MasterWIGA1.changeDateDate = ''
    state.adminUserChoice.MasterWIGA1.changeDateTmzn = ''
  },

  [types.ADMIN_USERCHOICE_WIGA1DETAIL_FIRSTDISPLAY](state) {
    // 予約状況詳細 初期表示
    // ukno以外の予約状況詳細カレンダー選択画面の各値をリセット
    state.adminUserChoice.MasterWIGA1.changeDateFlag = false
    state.adminUserChoice.MasterWIGA1.changeDateYear = 0
    state.adminUserChoice.MasterWIGA1.changeDateMonth = 0
    state.adminUserChoice.MasterWIGA1.changeDateDate = 0
    state.adminUserChoice.MasterWIGA1.changeDateTmzn = ''
  },

  [types.ADMIN_USERCHOICE_WIGA1DETAIL_RESET](state) {
    // 予約状況詳細で更新ボタン押下時
    // 予約状況詳細で戻る押下時（受診者抽出遷移する）
    // uknoを含む各値をリセット
    state.adminUserChoice.MasterWIGA1.ukno = ''
    state.adminUserChoice.MasterWIGA1.changeDateFlag = false
    state.adminUserChoice.MasterWIGA1.changeDateYear = 0
    state.adminUserChoice.MasterWIGA1.changeDateMonth = 0
    state.adminUserChoice.MasterWIGA1.changeDateDate = 0
    state.adminUserChoice.MasterWIGA1.changeDateTmzn = ''
  },

  [types.ADMIN_USERCHOICE_WIGA1_CHOICEDATETMZN](state, payload) {
    // 予約状況詳細カレンダー選択画面で変更日、変更時間帯を選んだ時
    state.adminUserChoice.MasterWIGA1.changeDateFlag = true
    state.adminUserChoice.MasterWIGA1.changeDateYear = payload.changeDateYear
    state.adminUserChoice.MasterWIGA1.changeDateMonth = payload.changeDateMonth
    state.adminUserChoice.MasterWIGA1.changeDateDate = payload.changeDateDate
    state.adminUserChoice.MasterWIGA1.changeDateTmzn = payload.changeDateTmzn
  },

  [types.ADMIN_USERCHOICE_CSVPATTERN_LISTTODETAIL](state, payload) {
    // CSVパターン一覧画面から詳細画面へ
    state.adminUserChoice.CSVPattern.ptcd = payload.ptcd
  },

  [types.ADMIN_USERCHOICE_CSVPATTERN_BACKTOLIST](state) {
    // CSVパターン詳細から一覧へ戻る
    state.adminUserChoice.CSVPattern.ptcd = ''
  },
  
  [types.ADMIN_USERCHOICE_WIRKN](state, payload) {
    // 医療機関の情報更新時に医療機関名を更新
    state.adminLoginUserInfo.irnm = payload.irnm
  },
  // 受診者抽出画面検索欄(検索ボタン押下時に保存)
  [types.ADMIN_WIGA1_SEARCH](state, payload) {

    state.adminWiga11Search.jgcd = payload.jgcd
    state.adminWiga11Search.jgnm = payload.jgnm
    state.adminWiga11Search.cmnm = payload.cmnm
    state.adminWiga11Search.hkkg = payload.hkkg
    state.adminWiga11Search.trno = payload.trno
    state.adminWiga11Search.waku = payload.waku
    state.adminWiga11Search.ukno = payload.ukno
    state.adminWiga11Search.nend = payload.nend
    state.adminWiga11Search.opbr = payload.opbr
    state.adminWiga11Search.opcd = payload.opcd

    state.adminWiga11Search.ykdyStartYear = payload.ykdyStartYear
    state.adminWiga11Search.ykdyStartMonth = payload.ykdyStartMonth
    state.adminWiga11Search.ykdyStartDate = payload.ykdyStartDate
    state.adminWiga11Search.ykdyEndYear = payload.ykdyEndYear
    state.adminWiga11Search.ykdyEndMonth = payload.ykdyEndMonth
    state.adminWiga11Search.ykdyEndDate = payload.ykdyEndDate

    state.adminWiga11Search.crdtStartYear = payload.crdtStartYear
    state.adminWiga11Search.crdtStartMonth = payload.crdtStartMonth
    state.adminWiga11Search.crdtStartDate = payload.crdtStartDate
    state.adminWiga11Search.crdtEndYear = payload.crdtEndYear
    state.adminWiga11Search.crdtEndMonth = payload.crdtEndMonth
    state.adminWiga11Search.crdtEndDate = payload.crdtEndDate

    state.adminWiga11Search.updtStartYear = payload.updtStartYear
    state.adminWiga11Search.updtStartMonth = payload.updtStartMonth
    state.adminWiga11Search.updtStartDate = payload.updtStartDate
    state.adminWiga11Search.updtEndYear = payload.updtEndYear
    state.adminWiga11Search.updtEndMonth = payload.updtEndMonth
    state.adminWiga11Search.updtEndDate = payload.updtEndDate
    
    state.adminWiga11Search.ykst = payload.ykst
    state.adminWiga11Search.ryak = payload.ryak
    state.adminWiga11Search.name = payload.name
    state.adminWiga11Search.csst = payload.csst
    state.adminWiga11Search.tmzn = payload.tmzn
  },
  // 受診者抽出画面絞り込み項目欄 ステータス
  [types.ADMIN_WIGA1_SEARCH_YKST](state, payload) { 
    state.adminWiga11Search.ykst = payload.ykst
  },
  // 受診者抽出画面絞り込み項目欄 ダウンロード状況
  [types.ADMIN_WIGA1_SEARCH_CSST](state, payload) {
    state.adminWiga11Search.csst = payload.csst
  },

  // 受診者抽出画面絞り込み項目欄 氏名（カナ）
  [types.ADMIN_WIGA1_SEARCH_RYAK](state, payload) {
    state.adminWiga11Search.ryak = payload.ryak
  },

  // 受診者抽出画面絞り込み項目欄 氏名（漢字）
  [types.ADMIN_WIGA1_SEARCH_NAME](state, payload) {
    state.adminWiga11Search.name = payload.name
  },

  // 受診者抽出画面絞り込み項目欄 受診時間
  [types.ADMIN_WIGA1_SEARCH_TMZN](state, payload) {
    state.adminWiga11Search.tmzn = payload.tmzn
  },

  // 以下より一般ユーザー系
  // 一般ユーザーログイン成功時
  // トークンを格納
  [types.COMMON_AUTH_LOGIN](state, payload) {
    state.auth.token = payload.token
    state.auth.userId = payload.userId
  },
  // ログアウト
  [types.COMMON_AUTH_LOGOUT](state) {
    state.auth.trsq = ''
    state.auth.token = ''
    state.commonUserInfo.name = ''
    // 管理ユーザーのストア値を全て初期化 
    state.adminLoginUserInfo.irnm = ''
    state.adminUserChoice.MasterWTMZN.tmzn = ''
    state.adminUserChoice.MasterWTMZN.err = ''
    state.adminUserChoice.MasterWKKMM.kmcd = ''
    state.adminUserChoice.MasterWMAIL.mrcd = ''
    state.adminUserChoice.MasterWOPBR.opbr = ''
    state.adminUserChoice.MasterWOPKM.opbr = ''
    state.adminUserChoice.MasterWOPKM.opcd = ''
    state.adminUserChoice.MasterWJGYO.jgcd = ''
    state.adminUserChoice.MasterWHFKB.jgcd = ''
    state.adminUserChoice.MasterWHFKB.hfkb = ''
    state.adminUserChoice.MasterWIRKS.nend = ''
    state.adminUserChoice.MasterWIRKS.jgcd = ''
    state.adminUserChoice.MasterWIRKS.kscd = ''
    state.adminUserChoice.MasterWIRKS.key = ''
    state.adminUserChoice.CSVPattern.ptcd = ''

    // 一般ユーザー各機能でのストア値を初期化

    // マイページ
    state.commonUserInfo.myPage.isUse = false
    //state.commonUserInfo.myPage.uknos = []
    state.commonUserInfo.myPage.choiceUkno = ''
    state.commonUserInfo.myPage.detailUkno = ''
    state.commonUserInfo.myPage.cancelUkno = ''

    // 新規健保予約画面
    state.commonUserInfo.newHealthInsurance.isUse = false
    state.commonUserInfo.newHealthInsurance.jgcd = ''
    state.commonUserInfo.newHealthInsurance.hksh = ''
    state.commonUserInfo.newHealthInsurance.sex = ''
    state.commonUserInfo.newHealthInsurance.btdyYear = 0
    state.commonUserInfo.newHealthInsurance.btdyMonth = 0
    state.commonUserInfo.newHealthInsurance.btdyDate = 0
    state.commonUserInfo.newHealthInsurance.nend = 0
    state.commonUserInfo.newHealthInsurance.age = 0
    state.commonUserInfo.newHealthInsurance.hfkb = ''

    // コース一覧画面
    state.commonUserInfo.selectCourse.kscd = ''
    state.commonUserInfo.selectCourse.jkcd = ''

    // オプション一覧画面
    state.commonUserInfo.selectOption.opbr = []
    state.commonUserInfo.selectOption.opcd = []
    state.commonUserInfo.selectOption.jkcd = []

    // カレンダー選択画面
    state.commonUserInfo.selectCalender.date = ''
    state.commonUserInfo.selectCalender.tmzn = ''

    // 予約情報入力画面
    state.commonUserInfo.inputReserveInfo.jgnm = ''
    state.commonUserInfo.inputReserveInfo.hkkg = ''
    state.commonUserInfo.inputReserveInfo.hkno = ''
    state.commonUserInfo.inputReserveInfo.cmnm = ''
    state.commonUserInfo.inputReserveInfo.nam1 = ''
    state.commonUserInfo.inputReserveInfo.nam2 = ''
    state.commonUserInfo.inputReserveInfo.ryk1 = ''
    state.commonUserInfo.inputReserveInfo.ryk2 = ''
    state.commonUserInfo.inputReserveInfo.zip1 = ''
    state.commonUserInfo.inputReserveInfo.zip2 = ''
    state.commonUserInfo.inputReserveInfo.adr1 = ''
    state.commonUserInfo.inputReserveInfo.adr2 = ''
    state.commonUserInfo.inputReserveInfo.adr3 = ''
    state.commonUserInfo.inputReserveInfo.tel1 = ''
    state.commonUserInfo.inputReserveInfo.syno = ''
    state.commonUserInfo.inputReserveInfo.email = ''
    state.commonUserInfo.inputReserveInfo.dmkb = ''
    state.commonUserInfo.inputReserveInfo.mem1 = ''
    state.commonUserInfo.inputReserveInfo.sex = ''
    state.commonUserInfo.inputReserveInfo.btdyYear = 0
    state.commonUserInfo.inputReserveInfo.btdyMonth = 0
    state.commonUserInfo.inputReserveInfo.btdyDate = 0
    state.commonUserInfo.inputReserveInfo.nend = 0
    state.commonUserInfo.inputReserveInfo.age = 0
    state.commonUserInfo.inputReserveInfo.hfkb = ''

    // 予約確認画面
    state.commonUserInfo.confirmReserveInfo.isUse = false
    state.commonUserInfo.confirmReserveInfo.age = 0

    // 途中ログイン
    state.commonUserInfo.enRouteLogin.isUse = false

    // :TODO 管理者ユーザーのストア値もリセットする
  },

  // 一般用ナビゲーション表示の切り替え
	// true: 表示
	// false: 非表示
  [types.COMMON_DISPLAYNAVIGATION](state, payload) {
    state.commonUserInfo.isDisplayNavigation = payload.isDisplayNavigation
  },

  // 一般ユーザーTOP画面　初期表示時、医療機関情報の登録
  [types.COMMON_SETIRKNINFO](state, payload) {
    // 医療機関コード
    state.auth.ircd = payload.ircd
    // URLパラメーター
    state.commonUserInfo.pram = payload.pram
    // 医療機関名称
    state.commonUserInfo.irnm = payload.irnm
    // 契約先 電話番号
    state.commonUserInfo.ktel = payload.ktel
    // 電話予約受付時間
    state.commonUserInfo.uktk = payload.uktk
    // 背景画像相対パス
    state.commonUserInfo.hmpg = payload.hmpg

  },
  // 一般ユーザーログイン成功時
  // 一般ユーザー情報を格納
  [types.COMMON_USERINFO_SETUSERINFO](state, payload) {
    state.auth.trsq = payload.trsq
    state.commonUserInfo.name = payload.name
    state.commonUserInfo.newHealthInsurance.jgcd = payload.jgcd
    state.commonUserInfo.newHealthInsurance.hksh = payload.hksh
    state.commonUserInfo.newHealthInsurance.sex = payload.sex
    state.commonUserInfo.newHealthInsurance.btdyYear = payload.btdyYear
    state.commonUserInfo.newHealthInsurance.btdyMonth = payload.btdyMonth
    state.commonUserInfo.newHealthInsurance.btdyDate = payload.btdyDate
    state.commonUserInfo.newHealthInsurance.age = payload.age
    state.commonUserInfo.newHealthInsurance.hfkb = payload.hfkb
  },
  // 一般ユーザー　マイページ 初期表示時
  [types.COMMON_MYPAGE_FIRSTDISPLAY](state) {
    state.commonUserInfo.myPage.isUse = true
    state.commonUserInfo.myPage.choiceUkno = ''
    state.commonUserInfo.myPage.detailUkno = ''
    state.commonUserInfo.myPage.cancelUkno = ''
  },
  // 一般ユーザー マイページ 個人として新規予約
  [types.COMMON_MYPAGE_RESERVEKOJIN](state,payload) {
    state.commonUserInfo.newHealthInsurance.jgcd = payload.jgcd
    state.commonUserInfo.newHealthInsurance.hksh = payload.hksh
    state.commonUserInfo.newHealthInsurance.sex = payload.sex
    state.commonUserInfo.newHealthInsurance.btdyYear = payload.btdyYear
    state.commonUserInfo.newHealthInsurance.btdyMonth = payload.btdyMonth
    state.commonUserInfo.newHealthInsurance.btdyDate = payload.btdyDate
    state.commonUserInfo.newHealthInsurance.nend = payload.nend
    state.commonUserInfo.newHealthInsurance.age = payload.age
    state.commonUserInfo.newHealthInsurance.hfkb = payload.hfkb
  },
  // 一般ユーザー マイページ 健保使って新規予約
  [types.COMMON_MYPAGE_RESERVEHELTH](state,payload) {
    state.commonUserInfo.newHealthInsurance.jgcd = payload.jgcd
    state.commonUserInfo.newHealthInsurance.hksh = payload.hksh
    state.commonUserInfo.newHealthInsurance.sex = payload.sex
    state.commonUserInfo.newHealthInsurance.btdyYear = payload.btdyYear
    state.commonUserInfo.newHealthInsurance.btdyMonth = payload.btdyMonth
    state.commonUserInfo.newHealthInsurance.btdyDate = payload.btdyDate
    state.commonUserInfo.newHealthInsurance.nend = payload.nend
    state.commonUserInfo.newHealthInsurance.age = payload.age
    state.commonUserInfo.newHealthInsurance.hfkb = payload.hfkb
  },
  // 一般ユーザー　マイページ 予約詳細ボタン押下時
  [types.COMMON_MYPAGE_RESERVEDETAIL](state, payload) {
    state.commonUserInfo.myPage.detailUkno = payload.detailUkno
  },
  // 一般ユーザー　マイページ 予約変更ボタン押下時
  [types.COMMON_MYPAGE_RESERVECHANGE](state, payload) {
    state.commonUserInfo.myPage.choiceUkno = payload.choiceUkno
    state.commonUserInfo.newHealthInsurance.jgcd = payload.jgcd
    state.commonUserInfo.newHealthInsurance.hksh = payload.hksh
    state.commonUserInfo.newHealthInsurance.sex = payload.sex
    state.commonUserInfo.newHealthInsurance.btdyYear = payload.btdyYear
    state.commonUserInfo.newHealthInsurance.btdyMonth = payload.btdyMonth
    state.commonUserInfo.newHealthInsurance.btdyDate = payload.btdyDate
    state.commonUserInfo.newHealthInsurance.nend = payload.nend
    state.commonUserInfo.newHealthInsurance.age = payload.age
    state.commonUserInfo.newHealthInsurance.hfkb = payload.hfkb
  },
  // 一般ユーザー　マイページ 予約キャンセルボタン押下時
  [types.COMMON_MYPAGE_RESERVECANCEL](state, payload) {
    state.commonUserInfo.myPage.cancelUkno = payload.cancelUkno
  },
  // 一般ユーザー 予約詳細 戻るボタン押下時
  [types.COMMON_RESERVEDETAIL_BACK](state) {
    state.commonUserInfo.myPage.detailUkno = ''
  },
  // 一般ユーザー 予約キャンセル確認 戻るボタン押下時
  [types.COMMON_CONFIRMCANCEL_BACK](state) {
    state.commonUserInfo.myPage.cancelUkno = ''
  },
  // 一般ユーザー 予約キャンセル確認 キャンセルを確定する押下時
  [types.COMMON_CONFIRMCANCEL_DECISION](state) {
    state.commonUserInfo.myPage.cancelUkno = ''
  },
  // 一般ユーザー 新規健保予約画面 年齢の登録
  [types.COMMON_NEWHEALTHINSURANCE](state, payload) {

    state.commonUserInfo.newHealthInsurance.isUse = true
    state.commonUserInfo.newHealthInsurance.jgcd = payload.jgcd
    state.commonUserInfo.newHealthInsurance.hksh = payload.hksh
    state.commonUserInfo.newHealthInsurance.sex = payload.sex
    state.commonUserInfo.newHealthInsurance.btdyYear = payload.btdyYear
    state.commonUserInfo.newHealthInsurance.btdyMonth = payload.btdyMonth
    state.commonUserInfo.newHealthInsurance.btdyDate = payload.btdyDate
    state.commonUserInfo.newHealthInsurance.nend = payload.nend
    state.commonUserInfo.newHealthInsurance.age = payload.age
    state.commonUserInfo.newHealthInsurance.hfkb = payload.hfkb
  },
  // 一般ユーザー　個人（新規健保予約画面を経由しない場合）
  [types.COMMON_KOJIN](state, payload) {

    state.commonUserInfo.newHealthInsurance.jgcd = '00000000'
    state.commonUserInfo.newHealthInsurance.hksh = '00000000'
    state.commonUserInfo.newHealthInsurance.sex = 'Z'
    state.commonUserInfo.newHealthInsurance.btdyYear = 0
    state.commonUserInfo.newHealthInsurance.btdyMonth = 0
    state.commonUserInfo.newHealthInsurance.btdyDate = 0
    state.commonUserInfo.newHealthInsurance.nend = payload.nend
    state.commonUserInfo.newHealthInsurance.age = 40
    state.commonUserInfo.newHealthInsurance.hfkb = 'Z'
  },
  // 一般ユーザー　新規健保予約画面 新規健保予約画面からマイページに戻る
  // ユーザータイプが1: マイページ経由かつ新規予約（健保）
  [types.COMMON_NEWHEALTHINSURANCE_BACK_USERTYPE1](state) {
    // 新規健保予約画面
    state.commonUserInfo.newHealthInsurance.isUse = false
    state.commonUserInfo.newHealthInsurance.jgcd = ''
    state.commonUserInfo.newHealthInsurance.hksh = ''
    state.commonUserInfo.newHealthInsurance.sex = ''
    state.commonUserInfo.newHealthInsurance.btdyYear = 0
    state.commonUserInfo.newHealthInsurance.btdyMonth = 0
    state.commonUserInfo.newHealthInsurance.btdyDate = 0
    state.commonUserInfo.newHealthInsurance.nend = 0
    state.commonUserInfo.newHealthInsurance.age = 0
    state.commonUserInfo.newHealthInsurance.hfkb = ''
  },
  // 一般ユーザー　新規健保予約画面 新規健保予約画面からマイページに戻る
  // ユーザータイプが3: マイページ経由かつ予約変更（健保）
  [types.COMMON_NEWHEALTHINSURANCE_BACK_USERTYPE3](state) {
    // マイページ
    state.commonUserInfo.myPage.choiceUkno = ''
    // 新規健保予約画面
    state.commonUserInfo.newHealthInsurance.isUse = false
    state.commonUserInfo.newHealthInsurance.jgcd = ''
    state.commonUserInfo.newHealthInsurance.hksh = ''
    state.commonUserInfo.newHealthInsurance.sex = ''
    state.commonUserInfo.newHealthInsurance.btdyYear = 0
    state.commonUserInfo.newHealthInsurance.btdyMonth = 0
    state.commonUserInfo.newHealthInsurance.btdyDate = 0
    state.commonUserInfo.newHealthInsurance.nend = 0
    state.commonUserInfo.newHealthInsurance.age = 0
    state.commonUserInfo.newHealthInsurance.hfkb = ''
  },
  // 一般ユーザー　新規健保予約画面 新規健保予約画面からトップ画面に戻る
  // ユーザータイプが5: ゲストログインかつ新規予約（健保）
  [types.COMMON_NEWHEALTHINSURANCE_BACK_USERTYPE5](state) {
    // 新規健保予約画面
    state.commonUserInfo.newHealthInsurance.isUse = false
    state.commonUserInfo.newHealthInsurance.jgcd = ''
    state.commonUserInfo.newHealthInsurance.hksh = ''
    state.commonUserInfo.newHealthInsurance.sex = ''
    state.commonUserInfo.newHealthInsurance.btdyYear = 0
    state.commonUserInfo.newHealthInsurance.btdyMonth = 0
    state.commonUserInfo.newHealthInsurance.btdyDate = 0
    state.commonUserInfo.newHealthInsurance.nend = 0
    state.commonUserInfo.newHealthInsurance.age = 0
    state.commonUserInfo.newHealthInsurance.hfkb = ''
  },
  // 一般ユーザー　コース選択画面
  [types.COMMON_SELECTCOURSE](state, payload) {
    state.commonUserInfo.selectCourse.kscd = payload.kscd
    state.commonUserInfo.selectCourse.jkcd = payload.jkcd
  },
  // 一般ユーザー　コース選択画面 コース選択画面からマイページに戻る
  // ユーザータイプが0: マイページ経由かつ新規予約（個人）
  [types.COMMON_SELECTCOURSE_BACK_USERTYPE0](state) {
    // コース選択画面のストア内容を初期化
    state.commonUserInfo.selectCourse.kscd = ''
    state.commonUserInfo.selectCourse.jkcd = ''
  },
  // 一般ユーザー　コース選択画面 コース選択画面から新規健保予約画面に戻る
  // ユーザータイプが1: マイページ経由かつ新規予約（健保）
  [types.COMMON_SELECTCOURSE_BACK_USERTYPE1](state) {
    // コース選択画面のストア内容を初期化
    state.commonUserInfo.selectCourse.kscd = ''
    state.commonUserInfo.selectCourse.jkcd = ''
  },
  // 一般ユーザー　コース選択画面 コース選択画面からマイページに戻る
  // ユーザータイプが2: マイページ経由かつ予約変更（個人）
  [types.COMMON_SELECTCOURSE_BACK_USERTYPE2](state) {

    // マイページ 変更する予約受付番号を初期化
    state.commonUserInfo.myPage.choiceUkno = ''
    // コース選択画面のストア内容を初期化
    state.commonUserInfo.selectCourse.kscd = ''
    state.commonUserInfo.selectCourse.jkcd = ''
  },
  // 一般ユーザー　コース選択画面 コース選択画面から新規健保予約画面に戻る
  // ユーザータイプが3: マイページ経由かつ予約変更（健保）
  [types.COMMON_SELECTCOURSE_BACK_USERTYPE3](state) {

    // マイページ 変更する予約受付番号を初期化
    state.commonUserInfo.myPage.choiceUkno = ''
    // コース選択画面のストア内容を初期化
    state.commonUserInfo.selectCourse.kscd = ''
    state.commonUserInfo.selectCourse.jkcd = ''
  },
  // 一般ユーザー　コース選択画面 コース選択画面からトップページに戻る
  // ユーザータイプが4: ゲストログインかつ新規予約（個人）
  [types.COMMON_SELECTCOURSE_BACK_USERTYPE4](state) {
    // コース選択画面のストア内容を初期化
    state.commonUserInfo.selectCourse.kscd = ''
    state.commonUserInfo.selectCourse.jkcd = ''
  },
  // 一般ユーザー　コース選択画面 コース選択画面から新規健保予約画面に戻る
  // ユーザータイプが5: ゲストログインかつ新規予約（健保）
  [types.COMMON_SELECTCOURSE_BACK_USERTYPE5](state) {
    // コース選択画面のストア内容を初期化
    state.commonUserInfo.selectCourse.kscd = ''
    state.commonUserInfo.selectCourse.jkcd = ''
  },
  // 一般ユーザー　コース選択画面 コース選択画面からトップページに戻る
  // ログアウト処理が行われる
  // ユーザータイプが6: 途中ログインかつ新規予約（個人）
  [types.COMMON_SELECTCOURSE_BACK_USERTYPE6](state) {

    state.auth.trsq = ''
    state.auth.token = ''
    state.commonUserInfo.name = ''

    // 一般ユーザー各機能でのストア値を初期化

    // マイページ
    state.commonUserInfo.myPage.isUse = false
    state.commonUserInfo.myPage.choiceUkno = ''

    // 新規健保予約画面
    state.commonUserInfo.newHealthInsurance.isUse = false
    state.commonUserInfo.newHealthInsurance.jgcd = ''
    state.commonUserInfo.newHealthInsurance.hksh = ''
    state.commonUserInfo.newHealthInsurance.sex = ''
    state.commonUserInfo.newHealthInsurance.btdyYear = 0
    state.commonUserInfo.newHealthInsurance.btdyMonth = 0
    state.commonUserInfo.newHealthInsurance.btdyDate = 0
    state.commonUserInfo.newHealthInsurance.nend = 0
    state.commonUserInfo.newHealthInsurance.age = 0
    state.commonUserInfo.newHealthInsurance.hfkb = ''

    // コース一覧画面
    state.commonUserInfo.selectCourse.kscd = ''
    state.commonUserInfo.selectCourse.jkcd = ''
  },
  // 一般ユーザー　コース選択画面 コース選択画面からトップページに戻る
  // ユーザータイプが7: 途中ログインかつ新規予約（健保）
  [types.COMMON_SELECTCOURSE_BACK_USERTYPE7](state) {
    
    state.auth.trsq = ''
    state.auth.token = ''
    state.commonUserInfo.name = ''

    // 一般ユーザー各機能でのストア値を初期化

    // マイページ
    state.commonUserInfo.myPage.isUse = false
    state.commonUserInfo.myPage.choiceUkno = ''

    // 新規健保予約画面
    state.commonUserInfo.newHealthInsurance.isUse = false
    state.commonUserInfo.newHealthInsurance.jgcd = ''
    state.commonUserInfo.newHealthInsurance.hksh = ''
    state.commonUserInfo.newHealthInsurance.sex = ''
    state.commonUserInfo.newHealthInsurance.btdyYear = 0
    state.commonUserInfo.newHealthInsurance.btdyMonth = 0
    state.commonUserInfo.newHealthInsurance.btdyDate = 0
    state.commonUserInfo.newHealthInsurance.nend = 0
    state.commonUserInfo.newHealthInsurance.age = 0
    state.commonUserInfo.newHealthInsurance.hfkb = ''

    // コース一覧画面
    state.commonUserInfo.selectCourse.kscd = ''
    state.commonUserInfo.selectCourse.jkcd = ''
  },
  // 一般ユーザー　オプション選択画面 初期表示
  [types.COMMON_SELECTOPTION_FIRSTDISPLAY](state) {
    state.commonUserInfo.selectCalender.isUse = false
  },
  // 一般ユーザー　オプション選択画面
  [types.COMMON_SELECTOPTION](state, payload) {
    state.commonUserInfo.selectOption.opbr = payload.opbr
    state.commonUserInfo.selectOption.opcd = payload.opcd
    state.commonUserInfo.selectOption.jkcd = payload.jkcd
  },
  // 一般ユーザー  オプション選択画面 オプション選択画面からコース選択画面に戻る
  [types.COMMON_SELECTOPTION_BACK](state) {
    state.commonUserInfo.selectOption.opbr = []
    state.commonUserInfo.selectOption.opcd = []
    state.commonUserInfo.selectOption.jkcd = []
  },
  // 一般ユーザー　カレンダー選択画面 初期表示
  [types.COMMON_SELECTCALENDER_FIRSTDISPLAY](state) {
    state.commonUserInfo.selectCalender.isUse = true
  },
  // 一般ユーザー　カレンダー選択画面 
  [types.COMMON_SELECTCALENDER](state, payload) {
    state.commonUserInfo.selectCalender.date = payload.date
    state.commonUserInfo.selectCalender.tmzn = payload.tmzn
  },
  // 一般ユーザー　カレンダー選択画面 カレンダー選択画面からオプション選択画面に戻る
  [types.COMMON_SELECTCALENDER_BACK](state) {
    state.commonUserInfo.selectCalender.date = ''
    state.commonUserInfo.selectCalender.tmzn = ''
  },
  // 一般ユーザー　予約情報入力画面 初期表示
  [types.COMMON_INPUTRESERVEINFO_FIRSTDISPLAY](state) {
    // 予約確認画面を通ったかどうか
    state.commonUserInfo.confirmReserveInfo.isUse = false
  },
  // 一般ユーザー　予約情報入力画面
  [types.COMMON_INPUTRESERVEINFO](state, payload) {
    // クライアントコード(健康保険組合名)
    state.commonUserInfo.inputReserveInfo.jgnm = payload.jgnm
    // 保険者番号（新規健保予約画面でも更新可能性あり）
    state.commonUserInfo.inputReserveInfo.hksh = payload.hksh
    // 保険証記号
    state.commonUserInfo.inputReserveInfo.hkkg = payload.hkkg
    // 保険証番号
    state.commonUserInfo.inputReserveInfo.hkno = payload.hkno
    // 対象者区分
    state.commonUserInfo.inputReserveInfo.hfkb = payload.hfkb
    // 企業名
    state.commonUserInfo.inputReserveInfo.cmnm = payload.cmnm
    // 漢字氏名
    state.commonUserInfo.inputReserveInfo.nam1 = payload.nam1
    state.commonUserInfo.inputReserveInfo.nam2 = payload.nam2
    // カナ氏名
    state.commonUserInfo.inputReserveInfo.ryk1 = payload.ryk1
    state.commonUserInfo.inputReserveInfo.ryk2 = payload.ryk2
    // 生年月日（個人情報登録用）
    state.commonUserInfo.inputReserveInfo.btdyYear = payload.btdyYear
    state.commonUserInfo.inputReserveInfo.btdyMonth = payload.btdyMonth
    state.commonUserInfo.inputReserveInfo.btdyDate = payload.btdyDate
    // 年齢（個人情報登録用）
    state.commonUserInfo.inputReserveInfo.age = payload.age
    // 性別（個人情報登録用）
    state.commonUserInfo.inputReserveInfo.sex = payload.sex
    // 住所
    state.commonUserInfo.inputReserveInfo.zip1 = payload.zip1
    state.commonUserInfo.inputReserveInfo.zip2 = payload.zip2
    state.commonUserInfo.inputReserveInfo.adr1 = payload.adr1
    state.commonUserInfo.inputReserveInfo.adr2 = payload.adr2
    state.commonUserInfo.inputReserveInfo.adr3 = payload.adr3
    // 電話番号（日中連絡先）
    state.commonUserInfo.inputReserveInfo.tel1 = payload.tel1
    // 社員番号
    state.commonUserInfo.inputReserveInfo.syno = payload.syno
    // メールアドレス
    state.commonUserInfo.inputReserveInfo.email = payload.email
    // ＤＭ・メルマガ
    state.commonUserInfo.inputReserveInfo.dmkb = payload.dmkb
    // 備考
    state.commonUserInfo.inputReserveInfo.mem1 = payload.mem1
  },
  // 一般ユーザー 予約情報入力画面 予約情報入力画面からカレンダー選択画面に戻る
  [types.COMMON_INPUTRESERVEINFO_BACK](state){

    state.commonUserInfo.inputReserveInfo.jgnm = ''
    state.commonUserInfo.inputReserveInfo.hksh = ''
    state.commonUserInfo.inputReserveInfo.hkkg = ''
    state.commonUserInfo.inputReserveInfo.hkno = ''
    state.commonUserInfo.inputReserveInfo.hfkb = ''
    state.commonUserInfo.inputReserveInfo.cmnm = ''
    state.commonUserInfo.inputReserveInfo.nam1 = ''
    state.commonUserInfo.inputReserveInfo.nam2 = ''
    state.commonUserInfo.inputReserveInfo.ryk1 = ''
    state.commonUserInfo.inputReserveInfo.ryk2 = ''
    state.commonUserInfo.inputReserveInfo.btdyYear = 0
    state.commonUserInfo.inputReserveInfo.btdyMonth = 0
    state.commonUserInfo.inputReserveInfo.btdyDate = 0
    state.commonUserInfo.inputReserveInfo.age = 0
    state.commonUserInfo.inputReserveInfo.sex = ''
    state.commonUserInfo.inputReserveInfo.zip1 = ''
    state.commonUserInfo.inputReserveInfo.zip2 = ''
    state.commonUserInfo.inputReserveInfo.adr1 = ''
    state.commonUserInfo.inputReserveInfo.adr2 = ''
    state.commonUserInfo.inputReserveInfo.adr3 = ''
    state.commonUserInfo.inputReserveInfo.tel1 = ''
    state.commonUserInfo.inputReserveInfo.syno = ''
    state.commonUserInfo.inputReserveInfo.email = ''
    state.commonUserInfo.inputReserveInfo.dmkb = ''
    state.commonUserInfo.inputReserveInfo.mem1 = ''
  },
  // 一般ユーザー　予約情報確認画面 初期表示
  [types.COMMON_CONFIRMRESERVE_FIRSTDISPLAY](state) {
    // 予約確認画面を通ったかどうか
    state.commonUserInfo.confirmReserveInfo.isUse = true
  },
  // 一般ユーザー　予約情報確認画面 各パラメーターリセット、ログイン情報登録
  [types.COMMON_CONFIRMRESERVE_REGISTERLOGININFO](state,payload) {
    // システムID
    state.auth.trsq = payload.trsq
    // 受診者名
    state.commonUserInfo.name = payload.name
    // マイページ関連
    state.commonUserInfo.myPage.isUse = false
    state.commonUserInfo.myPage.choiceUkno = ''
    // 新規健保予約画面
    state.commonUserInfo.newHealthInsurance.isUse = false
    state.commonUserInfo.newHealthInsurance.jgcd = ''
    state.commonUserInfo.newHealthInsurance.hksh = ''
    state.commonUserInfo.newHealthInsurance.sex = ''
    state.commonUserInfo.newHealthInsurance.btdyYear = 0
    state.commonUserInfo.newHealthInsurance.btdyMonth = 0
    state.commonUserInfo.newHealthInsurance.btdyDate = 0
    state.commonUserInfo.newHealthInsurance.nend = 0
    state.commonUserInfo.newHealthInsurance.age = 0
    state.commonUserInfo.newHealthInsurance.hfkb = ''
    // コース一覧画面
    state.commonUserInfo.selectCourse.kscd = ''
    state.commonUserInfo.selectCourse.jkcd = ''
    // オプション一覧画面
    state.commonUserInfo.selectOption.opbr = []
    state.commonUserInfo.selectOption.opcd = []
    state.commonUserInfo.selectOption.jkcd = []
    // カレンダー選択画面
    state.commonUserInfo.selectCalender.date = ''
    state.commonUserInfo.selectCalender.tmzn = ''
    // 予約情報入力画面
    state.commonUserInfo.inputReserveInfo.jgnm = ''
    state.commonUserInfo.inputReserveInfo.hkkg = ''
    state.commonUserInfo.inputReserveInfo.hkno = ''
    state.commonUserInfo.inputReserveInfo.cmnm = ''
    state.commonUserInfo.inputReserveInfo.nam1 = ''
    state.commonUserInfo.inputReserveInfo.nam2 = ''
    state.commonUserInfo.inputReserveInfo.ryk1 = ''
    state.commonUserInfo.inputReserveInfo.ryk2 = ''
    state.commonUserInfo.inputReserveInfo.zip1 = ''
    state.commonUserInfo.inputReserveInfo.zip2 = ''
    state.commonUserInfo.inputReserveInfo.adr1 = ''
    state.commonUserInfo.inputReserveInfo.adr2 = ''
    state.commonUserInfo.inputReserveInfo.adr3 = ''
    state.commonUserInfo.inputReserveInfo.tel1 = ''
    state.commonUserInfo.inputReserveInfo.syno = ''
    state.commonUserInfo.inputReserveInfo.email = ''
    state.commonUserInfo.inputReserveInfo.dmkb = ''
    state.commonUserInfo.inputReserveInfo.mem1 = ''
    state.commonUserInfo.inputReserveInfo.sex = ''
    state.commonUserInfo.inputReserveInfo.btdyYear = 0
    state.commonUserInfo.inputReserveInfo.btdyMonth = 0
    state.commonUserInfo.inputReserveInfo.btdyDate = 0
    state.commonUserInfo.inputReserveInfo.nend = 0
    state.commonUserInfo.inputReserveInfo.hfkb = ''
    // 予約確認画面
    state.commonUserInfo.confirmReserveInfo.isUse = false
    state.commonUserInfo.confirmReserveInfo.age = 0
    // 予約確定画面
    state.commonUserInfo.reserveResult.ukno = payload.ukno

    // 途中ログイン
    state.commonUserInfo.enRouteLogin.isUse = false
  },
  // 一般ユーザー 予約情報確認画面 既ログイン時 各パラメーターリセット、ユーザー情報一部再取得
  [types.COMMON_CONFIRMRESERVE_LOGINED](state,payload) {

    state.auth.userId = payload.userId
    state.commonUserInfo.name = payload.name
    // マイページ関連
    state.commonUserInfo.myPage.isUse = false
    state.commonUserInfo.myPage.choiceUkno = ''
    // 新規健保予約画面
    state.commonUserInfo.newHealthInsurance.isUse = false
    state.commonUserInfo.newHealthInsurance.jgcd = ''
    state.commonUserInfo.newHealthInsurance.hksh = ''
    state.commonUserInfo.newHealthInsurance.sex = ''
    state.commonUserInfo.newHealthInsurance.btdyYear = 0
    state.commonUserInfo.newHealthInsurance.btdyMonth = 0
    state.commonUserInfo.newHealthInsurance.btdyDate = 0
    state.commonUserInfo.newHealthInsurance.nend = 0
    state.commonUserInfo.newHealthInsurance.age = 0
    state.commonUserInfo.newHealthInsurance.hfkb = ''
    // コース一覧画面
    state.commonUserInfo.selectCourse.kscd = ''
    state.commonUserInfo.selectCourse.jkcd = ''
    // オプション一覧画面
    state.commonUserInfo.selectOption.opbr = []
    state.commonUserInfo.selectOption.opcd = []
    state.commonUserInfo.selectOption.jkcd = []
    // カレンダー選択画面
    state.commonUserInfo.selectCalender.date = ''
    state.commonUserInfo.selectCalender.tmzn = ''
    // 予約情報入力画面
    state.commonUserInfo.inputReserveInfo.jgnm = ''
    state.commonUserInfo.inputReserveInfo.hkkg = ''
    state.commonUserInfo.inputReserveInfo.hkno = ''
    state.commonUserInfo.inputReserveInfo.cmnm = ''
    state.commonUserInfo.inputReserveInfo.nam1 = ''
    state.commonUserInfo.inputReserveInfo.nam2 = ''
    state.commonUserInfo.inputReserveInfo.ryk1 = ''
    state.commonUserInfo.inputReserveInfo.ryk2 = ''
    state.commonUserInfo.inputReserveInfo.zip1 = ''
    state.commonUserInfo.inputReserveInfo.zip2 = ''
    state.commonUserInfo.inputReserveInfo.adr1 = ''
    state.commonUserInfo.inputReserveInfo.adr2 = ''
    state.commonUserInfo.inputReserveInfo.adr3 = ''
    state.commonUserInfo.inputReserveInfo.tel1 = ''
    state.commonUserInfo.inputReserveInfo.syno = ''
    state.commonUserInfo.inputReserveInfo.email = ''
    state.commonUserInfo.inputReserveInfo.dmkb = ''
    state.commonUserInfo.inputReserveInfo.mem1 = ''
    state.commonUserInfo.inputReserveInfo.sex = ''
    state.commonUserInfo.inputReserveInfo.btdyYear = 0
    state.commonUserInfo.inputReserveInfo.btdyMonth = 0
    state.commonUserInfo.inputReserveInfo.btdyDate = 0
    state.commonUserInfo.inputReserveInfo.nend = 0
    state.commonUserInfo.inputReserveInfo.hfkb = ''
    // 予約確認画面
    state.commonUserInfo.confirmReserveInfo.isUse = false
    state.commonUserInfo.confirmReserveInfo.age = 0
    // 予約確定画面
    state.commonUserInfo.reserveResult.ukno = payload.ukno
    // 途中ログイン
    state.commonUserInfo.enRouteLogin.isUse = false
  },
  // グローバルメニューからマイページへ遷移時 
  [types.COMMON_TO_MYPAGE](state) {
    // マイページ関連
    state.commonUserInfo.myPage.isUse = false
    state.commonUserInfo.myPage.choiceUkno = ''
    // 新規健保予約画面
    state.commonUserInfo.newHealthInsurance.isUse = false
    state.commonUserInfo.newHealthInsurance.jgcd = ''
    state.commonUserInfo.newHealthInsurance.hksh = ''
    state.commonUserInfo.newHealthInsurance.sex = ''
    state.commonUserInfo.newHealthInsurance.btdyYear = 0
    state.commonUserInfo.newHealthInsurance.btdyMonth = 0
    state.commonUserInfo.newHealthInsurance.btdyDate = 0
    state.commonUserInfo.newHealthInsurance.nend = 0
    state.commonUserInfo.newHealthInsurance.age = 0
    state.commonUserInfo.newHealthInsurance.hfkb = ''
    // コース一覧画面
    state.commonUserInfo.selectCourse.kscd = ''
    state.commonUserInfo.selectCourse.jkcd = ''
    // オプション一覧画面
    state.commonUserInfo.selectOption.opbr = []
    state.commonUserInfo.selectOption.opcd = []
    state.commonUserInfo.selectOption.jkcd = []
    // カレンダー選択画面
    state.commonUserInfo.selectCalender.date = ''
    state.commonUserInfo.selectCalender.tmzn = ''
    // 予約情報入力画面
    state.commonUserInfo.inputReserveInfo.jgnm = ''
    state.commonUserInfo.inputReserveInfo.hkkg = ''
    state.commonUserInfo.inputReserveInfo.hkno = ''
    state.commonUserInfo.inputReserveInfo.cmnm = ''
    state.commonUserInfo.inputReserveInfo.nam1 = ''
    state.commonUserInfo.inputReserveInfo.nam2 = ''
    state.commonUserInfo.inputReserveInfo.ryk1 = ''
    state.commonUserInfo.inputReserveInfo.ryk2 = ''
    state.commonUserInfo.inputReserveInfo.zip1 = ''
    state.commonUserInfo.inputReserveInfo.zip2 = ''
    state.commonUserInfo.inputReserveInfo.adr1 = ''
    state.commonUserInfo.inputReserveInfo.adr2 = ''
    state.commonUserInfo.inputReserveInfo.adr3 = ''
    state.commonUserInfo.inputReserveInfo.tel1 = ''
    state.commonUserInfo.inputReserveInfo.syno = ''
    state.commonUserInfo.inputReserveInfo.email = ''
    state.commonUserInfo.inputReserveInfo.dmkb = ''
    state.commonUserInfo.inputReserveInfo.mem1 = ''
    state.commonUserInfo.inputReserveInfo.sex = ''
    state.commonUserInfo.inputReserveInfo.btdyYear = 0
    state.commonUserInfo.inputReserveInfo.btdyMonth = 0
    state.commonUserInfo.inputReserveInfo.btdyDate = 0
    state.commonUserInfo.inputReserveInfo.nend = 0
    state.commonUserInfo.inputReserveInfo.hfkb = ''
    // 予約確認画面
    state.commonUserInfo.confirmReserveInfo.isUse = false
    state.commonUserInfo.confirmReserveInfo.age = 0
    // 途中ログイン
    state.commonUserInfo.enRouteLogin.isUse = false
  },
  // グローバルメニューからパスワード変更画面へ遷移時 
  [types.COMMON_TO_CHANGEPASSWORD](state) {
    // マイページ関連
    state.commonUserInfo.myPage.isUse = false
    state.commonUserInfo.myPage.choiceUkno = ''
    // 新規健保予約画面
    state.commonUserInfo.newHealthInsurance.isUse = false
    state.commonUserInfo.newHealthInsurance.jgcd = ''
    state.commonUserInfo.newHealthInsurance.hksh = ''
    state.commonUserInfo.newHealthInsurance.sex = ''
    state.commonUserInfo.newHealthInsurance.btdyYear = 0
    state.commonUserInfo.newHealthInsurance.btdyMonth = 0
    state.commonUserInfo.newHealthInsurance.btdyDate = 0
    state.commonUserInfo.newHealthInsurance.nend = 0
    state.commonUserInfo.newHealthInsurance.age = 0
    state.commonUserInfo.newHealthInsurance.hfkb = ''
    // コース一覧画面
    state.commonUserInfo.selectCourse.kscd = ''
    state.commonUserInfo.selectCourse.jkcd = ''
    // オプション一覧画面
    state.commonUserInfo.selectOption.opbr = []
    state.commonUserInfo.selectOption.opcd = []
    state.commonUserInfo.selectOption.jkcd = []
    // カレンダー選択画面
    state.commonUserInfo.selectCalender.date = ''
    state.commonUserInfo.selectCalender.tmzn = ''
    // 予約情報入力画面
    state.commonUserInfo.inputReserveInfo.jgnm = ''
    state.commonUserInfo.inputReserveInfo.hkkg = ''
    state.commonUserInfo.inputReserveInfo.hkno = ''
    state.commonUserInfo.inputReserveInfo.cmnm = ''
    state.commonUserInfo.inputReserveInfo.nam1 = ''
    state.commonUserInfo.inputReserveInfo.nam2 = ''
    state.commonUserInfo.inputReserveInfo.ryk1 = ''
    state.commonUserInfo.inputReserveInfo.ryk2 = ''
    state.commonUserInfo.inputReserveInfo.zip1 = ''
    state.commonUserInfo.inputReserveInfo.zip2 = ''
    state.commonUserInfo.inputReserveInfo.adr1 = ''
    state.commonUserInfo.inputReserveInfo.adr2 = ''
    state.commonUserInfo.inputReserveInfo.adr3 = ''
    state.commonUserInfo.inputReserveInfo.tel1 = ''
    state.commonUserInfo.inputReserveInfo.syno = ''
    state.commonUserInfo.inputReserveInfo.email = ''
    state.commonUserInfo.inputReserveInfo.dmkb = ''
    state.commonUserInfo.inputReserveInfo.mem1 = ''
    state.commonUserInfo.inputReserveInfo.sex = ''
    state.commonUserInfo.inputReserveInfo.btdyYear = 0
    state.commonUserInfo.inputReserveInfo.btdyMonth = 0
    state.commonUserInfo.inputReserveInfo.btdyDate = 0
    state.commonUserInfo.inputReserveInfo.nend = 0
    state.commonUserInfo.inputReserveInfo.hfkb = ''
    // 予約確認画面
    state.commonUserInfo.confirmReserveInfo.isUse = false
    state.commonUserInfo.confirmReserveInfo.age = 0
    // 途中ログイン
    state.commonUserInfo.enRouteLogin.isUse = false
  },
}



// WEBPACK FOOTER //
// ./src/store/mutations.js